import * as type from '../mutation-types';

const myCollect = {
    namespaced: true,
    state: {
        myCollectBatch: false, // 商标经纪人的批量操作标识
    },
    getters: {},
    mutations: {
        [type.SET_MY_COLLECT_BATCH](state, payload) {
            state.myCollectBatch = payload;
        },
        
    },
    actions: {}
};

export default myCollect;
